import React, { FunctionComponent } from 'react';
import styled from 'styled-components';
import { Link } from '@/components/Link';
import { wagwebTheme } from '@/theme/wagwebTheme';
import { Flex } from '../../../wag-react/next-components/Flex';
import { Span } from '../../../wag-react/core-components/span';
import { Box, BoxProps } from '../../../wag-react/next-components/box';
export type HealthArticleBannerButtonProps = BoxProps & {
  title: string;
  id: string;
};
export const HealthArticleBannerButton = ({
  title,
  id,
  ...rest
}) => <Button flex={['unset', 'unset', 1]} key={title} border="1px solid #D8D8D9" borderRadius="100px" {...rest} data-sentry-element="Button" data-sentry-component="HealthArticleBannerButton" data-sentry-source-file="index.tsx">
    <Link href={`#${id}`} data-sentry-element="Link" data-sentry-source-file="index.tsx">
      <Flex justifyContent={['center', 'center', 'center']} flexDirection={['row', 'row', 'row-reverse']} alignItems="center" px="16px" data-sentry-element="Flex" data-sentry-source-file="index.tsx">
        <Span fontWeight="bold" my="16px" color={wagwebTheme.colors.nero} px={['unset', 'unset', '16px']} hover data-sentry-element="Span" data-sentry-source-file="index.tsx">
          {title}
        </Span>
      </Flex>
    </Link>
  </Button>;
const Button = styled(Box)`
  transition: 0.3s all ease-out;
  &:hover {
    background-color: #00BF8F;
    border-color: #009972;
    span {
      color: white !important;
      transition: 0.3s all ease-out;
    }
  }
` as FunctionComponent<React.PropsWithChildren<BoxProps>>;